/**
 * signedDocument.ts — open a short-TTL signed read URL in a new tab, once,
 * without ever parking it anywhere.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: engagement unlock (2026-09-23).
 *
 * WHY A PROGRAMMATIC ANCHOR AND NEVER AN `<a href>` AT REST. A signed GCS
 * read URL is a bearer capability — anyone holding the string can read the
 * document with no session (the PhotoLightbox argument, one media type over).
 * An anchor sitting in the DOM puts it in the copy-link menu, the hover
 * status bar and any DOM snapshot; assigning it to `location` puts it in the
 * address bar and history. Building a transient anchor and clicking it (the
 * `openPrescriptionPdf` idiom in api/pharmacy.ts) opens the document in a new
 * tab and leaves nothing behind.
 *
 * `rel="noopener noreferrer"` because the destination is a storage origin,
 * not this app: it gets no handle on the opener window and no Referer naming
 * the page the click came from.
 *
 * WHY THE URL IS NOT RE-FETCHED THROUGH OUR CLIENT: the whole point of the
 * signed URL is that the SERVER already authorised this one read; proxying it
 * through the gateway would re-open the question the signature answered.
 */
export function openSignedDocument(url: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
